import { render } from "./TemplateEditorModal.vue?vue&type=template&id=070a2728&scoped=true"
import script from "./TemplateEditorModal.vue?vue&type=script&lang=js"
export * from "./TemplateEditorModal.vue?vue&type=script&lang=js"

import "./TemplateEditorModal.vue?vue&type=style&index=0&id=070a2728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070a2728"]])

export default __exports__